<template>
    <Paper class="company-prefix">
        <el-form ref="form" :model="enterpriseInf" label-width="0px" label-position="left" :rules="rules">
            <h6 class="company-prefix-title first-title">
                <span class="company-prefix-title-icon"></span>
                <span class="company-prefix-title-main">
                    {{$translate('lang.E3202103160010', { defaultText: '前缀信息' })}}
                </span>
            </h6>
                    <div class="company-prefix-item">
                       <span class="company-prefix-item-title">
                        {{$translate('lang.E3202103160011', { defaultText: '前缀' })}}:
                        </span>
                        <el-form-item class="company-prefix-item-input" prop="prefixCode">
                        <el-input  v-model="enterpriseInf.prefixCode" :disabled="topCheck" maxlength="17"></el-input>
                    </el-form-item>
                   </div>
                    <div class="company-prefix-item">
                       <span class="company-prefix-item-title">
                        {{$translate('lang.E3202103160012', { defaultText: '注册机构' })}}:
                        </span>
                        <el-form-item class="company-prefix-item-input" prop="registrationAuthority">
                        <el-input v-model="enterpriseInf.registrationAuthority" :disabled="topCheck" maxlength="100"></el-input>
                    </el-form-item>
                   </div>
                    <div class="company-prefix-item">
                       <span class="company-prefix-item-title">
                        {{$translate('lang.E3202103160013', { defaultText: '注册时间' })}}:
                       </span>
                        <el-form-item class="company-prefix-item-input" prop="registerTime">
                            <el-date-picker
                                class="company-prefix-item-input-time"
                                v-model="enterpriseInf.registerTime"
                                type="datetime"
                                :disabled="topCheck"
                                format='yyyy-MM-dd HH:mm:ss'
                                value-format='yyyy-MM-dd HH:mm:ss'
                                :placeholder="$translate('lang.E3202101280018', { defaultText: '选择日期' })">
                            </el-date-picker>
                        </el-form-item>
                   </div>
                    <div class="company-prefix-item">
                        <span class="company-prefix-item-title">
                            {{$translate('lang.E3202103160014', { defaultText: '注册状态' })}}:
                        </span>
                        <el-form-item class="company-prefix-item-input" >
                        <el-input
                            :value="enterpriseInf.registerStatus==='Y'?$translate('lang.E3202103160025', { defaultText: '正常' }):$translate('lang.E3202103160026', { defaultText: '未认证' })"
                            disabled>
                        </el-input>
                    </el-form-item>
                   </div>
            <h6 class="company-prefix-title">
                <span class="company-prefix-title-icon"></span>
                <span class="company-prefix-title-main">
                    {{$translate('lang.E3202103160015', { defaultText: '企业信息' })}}
                </span>
            </h6>
                  <div class="company-prefix-item">
                        <span class="company-prefix-item-title">
                            {{$translate('lang.E3202103160016', { defaultText: '中文名称' })}}:
                        </span>
                            <el-form-item class="company-prefix-item-input">
                            <el-input v-model="enterpriseInf.cnName" :disabled="bottomCheck" maxlength="100"></el-input>
                        </el-form-item>
                   </div>
                    <div class="company-prefix-item">
                        <span class="company-prefix-item-title">
                            {{$translate('lang.E3202103160017', { defaultText: '官方地址' })}}:
                        </span>
                        <el-form-item class="company-prefix-item-input">
                        <el-input v-model="enterpriseInf.website" :disabled="bottomCheck" maxlength="200"></el-input>
                    </el-form-item>
                   </div>
                    <div class="company-prefix-item">
                        <span class="company-prefix-item-title">
                            {{$translate('lang.E3202103160018', { defaultText: '所属行业' })}}:
                        </span>
                        <el-form-item class="company-prefix-item-input">
                        <el-input v-model="enterpriseInf.industry" :disabled="bottomCheck" maxlength="20"></el-input>
                    </el-form-item>
                   </div>
                    <div class="company-prefix-item">
                        <span class="company-prefix-item-title">
                            {{$translate('lang.E3202103160019', { defaultText: '中文地址' })}}:
                        </span>
                        <el-form-item class="company-prefix-item-input">
                        <el-input v-model="enterpriseInf.officialAddress" :disabled="bottomCheck" maxlength="200"></el-input>
                    </el-form-item>
                   </div>
                    <div class="company-prefix-textarea">
                        <span class="company-prefix-textarea-title">
                            {{$translate('lang.E3202103160020', { defaultText: '企业简介' })}}:
                        </span>
                        <el-form-item class="company-prefix-textarea-input">
                            <el-input
                                type="textarea"
                                :rows="6"
                                v-model="enterpriseInf.enterpriseIntroduction"
                                :placeholder="$translate('lang.E3202103160021', { defaultText: '请输入企业简介' })"
                                :disabled="bottomCheck"
                                maxlength="2000"
                                show-word-limit>
                            </el-input>
                    </el-form-item>
                   </div>
        </el-form>
        <el-button @click="send" class="company-prefix-button" size="mini" type="primary" :loading="saveBlock">
            {{$translate('lang.E3202103010008', { defaultText: '保存' })}}
        </el-button>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import { newCompany, searchCompany } from '../../../api/systemManagementApi';
import { mapGetters } from 'vuex';
export default {
    data() {
        const validator = (rule, value, callback) => {
            const reg = /^(88.182.)\d{1,10}$/;
            if (reg.test(value)) {
                callback();
            } else {
                callback(new Error(this.$translate('lang.EXC202103160002', { defaultText: '企业前缀不合法,必须[88.182.]起' })));
            }
        };
        return {
            saveBlock: false,
            topCheck: true,
            bottomCheck: true,
            enterpriseInf: {
                id: '',
                prefixCode: '',
                registrationAuthority: '',
                registerStatus: 'Y',
                registerTime: '',
                cnName: '',
                website: '',
                industry: '',
                officialAddress: '',
                enterpriseIntroduction: '',
                version: ''
            },
            tenantCode: '',
            rules: {
                prefixCode: [{ required: true, message: this.$translate('lang.E3202103160022', { defaultText: '请输入前缀信息' }), trigger: 'change' },
                    { validator: validator }
                ],
                registrationAuthority: [{ required: true, message: this.$translate('lang.E3202103160023', { defaultText: '请输入注册机构' }), trigger: 'change' }],
                registerTime: [{ required: true, message: this.$translate('lang.E3202103160024', { defaultText: '请选择注册时间' }), trigger: 'change' }]
            }
        };
    },
    methods: {
        // 保存按钮
        send() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.saveBlock = true;
                    newCompany(this.enterpriseInf).then(res => {
                        if (res.code === '0') {
                            this.$message.success(this.$translate('lang.EXC202103010014', { defaultText: '保存成功' }));
                            this.$eventBus.$emit('closeTag', this.$route);
                            this.$router.go(-1);
                        }
                        this.saveBlock = false;
                    }).catch(() => {
                        this.saveBlock = false;
                    });
                } else {
                    return false;
                }
            });
        },
        // 获取
        search(tenantCode) {
            searchCompany(tenantCode).then(res => {
                if (+res.code === 0) {
                    this.bottomCheck = false;
                    Object.keys(this.enterpriseInf).forEach(key => {
                        this.enterpriseInf[key] = res.data[key];
                    });
                    if (this.enterpriseInf.registerStatus === 'N') {
                        this.topCheck = true;
                    }
                } else {
                    this.$message.warning(this.$translate('lang.EXC202103160001', { defaultText: '请联系管理员，注册企业信息' }));
                }
            });
        }
    },
    computed: {
        ...mapGetters(['user', 'currentTenant'])
    },
    components: {
        Paper
    },
    created() {
        this.tenantCode = this.currentTenant.tenantCode;
        if (/^T/.test(this.tenantCode)) {
            this.bottomCheck = false;
            this.topCheck = false;
        } else {
            this.search(this.currentTenant.tenantCode);
        }
    }
};
</script>
<style lang="less">
.company-prefix{
    overflow: auto;
    font-size: 14px;
    // 企业前缀、企业信息
    .company-prefix-item{
         float: left;
        width: 50%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        font-size: 14px;
        margin-bottom: 20px;
    .company-prefix-item-title{
        width: 74px;
        text-align: right;
        margin-right: 10px;
    }
    .company-prefix-item-input{
        margin-bottom: 0;
        width: calc(100% - 120px);
    }
    }
    // 文本域-单独设置
    .company-prefix-textarea{
        width: 100%;
        display: flex;
        box-sizing: border-box;
        .company-prefix-textarea-title{
        width: 74px;
        text-align: right;
        margin-right: 10px;
        }
        .company-prefix-textarea-input{
        width: calc(100% - 120px);
        }
    }
    .company-prefix-item-input-time{
        width: 100%;
    }
    // 文字前-蓝色标识
.company-prefix-title{
    display: flex;
    align-items: center;
    width: 100%;
    .company-prefix-title-icon{
        width: 2px;
        height: 18px;
        display: inline-block;
        margin-right: 10px;
        background-color:#4285f5;
    }
    .company-prefix-title-main{
        font-size: 16px;
    }
}
.first-title{
    margin-top: 0px
}
// 保存按钮
.company-prefix-button{
    margin-left: 85px;
    width: 60px;
}
}

</style>